import { SpecialFreightIdView } from '../../../../models';

export class ShipmentSpecialFreightOverview {
  public static readonly type = '[ShipmentSpecialFreight] SOFA Overview';
  constructor(public payload: SpecialFreightIdView) {}
}

export class ShipmentSpecialFreightOverviewSetInitialState {
  public static readonly type = '[ShipmentSpecialFreight] Set SOFA Initial State';
}
